import {type AppDispatch, type RootState} from "../../../../store";
import {landlordAddUnitWriteToStorageV2} from "../utils/landlordAddUnitHandleStorageV2";
import {landlordSaveUnit} from "./landlordSaveUnit";

export const landlordCreateUnitUnitFeatures  = (unitID?: number) => (data: any) => async (dispatch: AppDispatch, getState: () => RootState): Promise<any> => {
    landlordAddUnitWriteToStorageV2('landlord_create_unit_unit_features', data)
    return await dispatch(landlordSaveUnit(unitID))
}